<template>
  <div class="row login-preview text-center mb-5" v-if="preview.logo">
    <div class="col-2"></div>
    <div class="col-8">
      <div>
        <img :src="preview.logo">
      </div>

      <h2>Hej, {{ preview.name }}</h2>
    </div>
    <div class="col-2"></div>
  </div>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "LoginPreview",
    computed: {
      ...mapState({
        preview: state => state.auth.preview
      })
    },
    props: {
      handle: {
        required: true,
        format: String
      }
    },
    async mounted() {
      this.showLoader()

      const handle = this.sanitizeHandle(this.handle)

      await this.$store.dispatch('fetchCompanyPreview', handle)

      if(this.preview.name === undefined){
        this.$router.push({name: 'index'})
      }

      this.hideLoader()
    },
    methods: {
      sanitizeHandle(string) {

        if (string === null || string === '') {
          return null
        }

        string = string.toString()

        return string.replace(/[^\x20-\x7E]/g, '')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Auth/Partials/LoginPreview.vue